import { createBrowserClient } from "@supabase/ssr";
import { getWidgetBaseUrl } from "./origin";

let client: ReturnType<typeof createBrowserClient> | null = null;

function buildCookieOptions() {
  const isSubmagic = new URL(getWidgetBaseUrl()).hostname.endsWith(
    ".submagic.co"
  );
  return {
    ...(isSubmagic ? { domain: ".submagic.co" } : {}),
    sameSite: "lax" as const,
    secure: isSubmagic,
    path: "/",
  };
}

export function getSupabase() {
  if (!client) {
    client = createBrowserClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
      {
        auth: { persistSession: true },
        cookieOptions: buildCookieOptions(),
      }
    );
  }
  return client;
}

export async function signInAnonymouslyIfNeeded() {
  const supabase = getSupabase();
  const { data } = await supabase.auth.getSession();
  if (!data.session) {
    const { error } = await supabase.auth.signInAnonymously();
    if (error) throw new Error(`Anonymous sign-in failed: ${error.message}`);
  }
}
